type UserLike = { rights?: string[] } | null | undefined;

interface CanCreateArgs {
    user: UserLike;
    role108: number | undefined;
    hasRightToCreate: boolean;
}

export const canCreateKnisa = ({ user, role108, hasRightToCreate }: CanCreateArgs): boolean => {
    return Boolean(user?.rights?.includes('OFFICE')) || role108 === 5 || hasRightToCreate;
};
